import { render, staticRenderFns } from "./VInputFileDrag.vue?vue&type=template&id=4d2288cc&scoped=true"
import script from "./VInputFileDrag.vue?vue&type=script&lang=js"
export * from "./VInputFileDrag.vue?vue&type=script&lang=js"
import style0 from "./VInputFileDrag.vue?vue&type=style&index=0&id=4d2288cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2288cc",
  null
  
)

export default component.exports